import { connect } from '@lumapps/redux/react';
import { currentLanguageSelector } from '@lumapps/translations/ducks/selectors';

import { getFavoriteDirectories } from '../../ducks/selectors';
import { Favorites } from './Favorites';

const mapStateToProps = (state: FrontOfficeStore) => ({
    directories: getFavoriteDirectories(state),
    language: currentLanguageSelector(state),
});

const ConnectedFavorites = connect(mapStateToProps)(Favorites);

export { ConnectedFavorites as Favorites };
